// TIP-614 — ONE Stripe.js instance for the whole app.
//
// `loadStripe` was being called in three places: App.js, PaymentsDetailsForm.jsx
// and PaymentsDetailsForm1.jsx. Each call loads and initialises its own
// Stripe.js, so the app ran several in parallel — extra network, extra
// fingerprinting scripts, and (the reason this ticket names it) a real risk of
// mounting Embedded Checkout against a different instance than the Elements
// provider above it.
//
// The two form components also called it INSIDE the component body, so a new
// promise was created on every render.
//
// Lives in utils/ rather than lib/: the repo's .gitignore carries a bare
// `lib/` rule for build output, which matches src/lib at any depth — a file
// here would have been silently untracked and everyone else's build would
// have failed on three missing imports.
//
// Module scope, so the promise is created once at import and every caller
// shares it. Exported as a promise rather than a getter because that is what
// <Elements stripe> and <EmbeddedCheckoutProvider stripe> both expect.
import { loadStripe } from "@stripe/stripe-js";

export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY;

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export default stripePromise;
